import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    data: false,
    hover:false,
    error: null,
    loading: false,
}


export const SidebarSlice = createSlice({
    name: 'SidebarSlice',
    initialState: initialState,
    reducers: {
        toggleSidebar: (state, action) => {
            state.data = action.payload
            return state
        },
        hoverSidebar: (state, action) => {
            state.hover = action.payload
            return state
        },
    },
    extraReducers: (builder) => {
        builder.addCase('LOGOUT', () => initialState)
    }
})

export const { toggleSidebar, hoverSidebar } = SidebarSlice.actions
export default SidebarSlice.reducer